// Color validation regex patterns
const hexRegex = /^#([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
const rgbRegex =
  /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(\d*(?:\.\d+)?))?\s*\)$/i;
const cmykRegex =
  /^cmyk\(\s*(\d*(?:\.\d+)?%?)\s*,\s*(\d*(?:\.\d+)?%?)\s*,\s*(\d*(?:\.\d+)?%?)\s*,\s*(\d*(?:\.\d+)?%?)\s*\)$/i;

export const convertToHex = (value: string): string => {
  if (hexRegex.test(value)) {
    let hex = value.substring(1);

    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((h) => h + h)
        .join("");
    } else if (hex.length === 4) {
      hex = hex
        .split("")
        .map((h) => h + h)
        .join("")
        .substring(0, 6);
    } else if (hex.length === 8) {
      hex = hex.substring(0, 6);
    }

    return `#${hex.substring(0, 6).toLowerCase()}`;
  }

  if (rgbRegex.test(value)) {
    const matches = value.match(rgbRegex);
    if (!matches) return "#FFFFFF";

    const r = parseInt(matches[1], 10);
    const g = parseInt(matches[2], 10);
    const b = parseInt(matches[3], 10);

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
  }

  if (cmykRegex.test(value)) {
    const matches = value.match(cmykRegex);
    if (!matches) return "#FFFFFF";

    let c = parseFloat(matches[1]) / 100;
    let m = parseFloat(matches[2]) / 100;
    let y = parseFloat(matches[3]) / 100;
    let k = parseFloat(matches[4]) / 100;

    if (isNaN(c)) c = 0;
    if (isNaN(m)) m = 0;
    if (isNaN(y)) y = 0;
    if (isNaN(k)) k = 0;

    const r = Math.round(255 * (1 - c) * (1 - k));
    const g = Math.round(255 * (1 - m) * (1 - k));
    const b = Math.round(255 * (1 - y) * (1 - k));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
  }

  return "#FFFFFF";
};

export const validateColor = (value: string): boolean => {
  value = value.trim();

  if (hexRegex.test(value)) {
    return true;
  } else if (rgbRegex.test(value)) {
    const matches = value.match(rgbRegex);
    if (!matches) return false;

    const r = parseInt(matches[1], 10);
    const g = parseInt(matches[2], 10);
    const b = parseInt(matches[3], 10);
    return r >= 0 && r <= 255 && g >= 0 && g <= 255 && b >= 0 && b <= 255;
  } else if (cmykRegex.test(value)) {
    const matches = value.match(cmykRegex);
    if (!matches) return false;

    const c = parseFloat(matches[1]);
    const m = parseFloat(matches[2]);
    const y = parseFloat(matches[3]);
    const k = parseFloat(matches[4]);
    return (
      c >= 0 &&
      c <= 100 &&
      m >= 0 &&
      m <= 100 &&
      y >= 0 &&
      y <= 100 &&
      k >= 0 &&
      k <= 100
    );
  }

  return false;
};
